/**
 * DeleteStageDialog — confirmation surface for deleting a pipeline stage
 * (SE-5488). Maps a resolved deletion plan onto the shared
 * ConfirmDialog (block-on-cards / warn-on-rules / plain confirm).
 * @module features/player-kanban/components/molecules/DeleteStageDialog
 */

export { default } from "./DeleteStageDialogContainer";
export type { DeleteStageDialogContainerProps } from "./DeleteStageDialogContainer";
export type {
  DeleteStageDialogViewProps,
  DialogCopy,
} from "./DeleteStageDialogView";
